module.exports = __webpack_public_path__ + "static/img/sjz.473e76d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sjz.jpg
// module id = Umbh
// module chunks = 1